import React from 'react';
import { AuthConfigurationSection } from './stripe-configuration-components';

export type StripeConfigurationProps = {
  apiToken: string;
};

export const StripeConfiguration: React.FC<StripeConfigurationProps> = ({ apiToken }) => {
  return (
    <div
      className='relative flex h-fit min-h-fit flex-col gap-5 p-16'
    >
      <AuthConfigurationSection apiToken={apiToken}/>
    </div>
  );
};